<template>
  <div
    :class="{
      InsetMap: true,
      open
    }"
  >
    <div class="close-button" @click="$store.dispatch('setInsetClosed')">
      &times;
    </div>
    <MglMap
      :accessToken="mapboxGlAccessToken"
      :center="sunsetCenter"
      :mapStyle="mapboxGlStyle"
      :zoom="9"
      :scrollZoom="false"
      :boxZoom="false"
      :doubleClickZoom="false"
      :dragPan="false"
      :dragRotate="false"
      :keyboard="false"
      :touchZoomRotate="false"
      @load="onMapLoaded"
    >
      <MglGeojsonLayer
        :sourceId="markerSourceOuter.data.id"
        :source="markerSourceOuter"
        :layerId="markerOuterLayer.id"
        :layer="markerOuterLayer"
      />
      <MglGeojsonLayer
        :sourceId="markerSourceInner.data.id"
        :source="markerSourceInner"
        :layerId="markerLayer.id"
        :layer="markerLayer"
      />
    </MglMap>
  </div>
</template>

<script>
import { MglMap, MglGeojsonLayer } from "vue-mapbox";
import { ResizeObserver } from "@juggle/resize-observer";
import * as turf from "@turf/turf";
import { mapboxGlAccessToken, mapboxGlStyle } from "../constants/constants";

export default {
  name: "InsetMap",
  components: {
    MglMap,
    MglGeojsonLayer
  },
  data() {
    return {
      mapboxGlAccessToken,
      mapboxGlStyle,
      markerLayer: {
        id: "marker",
        type: "circle",
        paint: {
          "circle-color": "#c04323"
        }
      },
      markerOuterLayer: {
        id: "markerOuter",
        type: "circle",
        paint: {
          "circle-opacity": 0,
          "circle-radius": 7,
          "circle-stroke-color": "#c04323",
          "circle-stroke-width": 1
        }
      },
      sunsetBounds: [-118.56, 34.04, -118.22, 34.09]
    };
  },
  computed: {
    markerSource() {
      const point = this.$store.getters.currentLatLonZoom.point;
      const featureCollection = turf.featureCollection([
        point ? turf.point(point) : null
      ]);
      featureCollection.id = "markerSource";
      return {
        type: "geojson",
        data: featureCollection
      };
    },

    markerSourceInner() {
      return {
        ...this.markerSource,
        data: {
          ...this.markerSource.data,
          id: "markerSourceInner"
        }
      };
    },

    markerSourceOuter() {
      return {
        ...this.markerSource,
        data: {
          ...this.markerSource.data,
          id: "markerSourceOuter"
        }
      };
    },

    open() {
      return this.$store.state.inset.open;
    },
    sunsetCenter() {
      return [
        (this.sunsetBounds[0] + this.sunsetBounds[2]) / 2,
        (this.sunsetBounds[1] + this.sunsetBounds[3]) / 2
      ];
    }
  },
  mounted() {
    const ro = new ResizeObserver(this.resize);
    ro.observe(this.$el);
    this.resizeObserver = ro;
  },
  beforeDestroy() {
    this.resizeObserver.unobserve(this.$el);
  },
  methods: {
    fitSunset() {
      if (!this.map) return;
      this.map.fitBounds(this.sunsetBounds, {
        animate: false,
        padding: { left: 15, right: 15 }
      });
      this.map.resize();
    },
    handleSunsetClick(e) {
      this.$store.dispatch("goToLngLat", { lngLat: e.lngLat });
    },
    onMapLoaded({ map }) {
      this.map = map;
      this.map.on(
        "click",
        "sunset-outline-click-target",
        this.handleSunsetClick
      );

      this.map.on("mouseenter", "sunset-outline-click-target", () => {
        this.map.getCanvas().style.cursor = "pointer";
      });

      this.map.on("mouseleave", "sunset-outline-click-target", () => {
        this.map.getCanvas().style.cursor = "";
      });

      this.fitSunset();
    },
    resize() {
      this.fitSunset();
    }
  },
  watch: {
    open() {
      if (this.open) {
        this.fitSunset();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/constants/_variables.scss";
$containerWidth: 350px;

.InsetMap {
  border: 2px solid black;
  height: 100%;
  left: -$containerWidth;
  position: absolute;
  transition: 0.3s left;
  max-width: 40vw;
  pointer-events: all;
  width: $containerWidth;

  &.open {
    left: 3px;
  }
}

.close-button {
  cursor: pointer;
  font-size: 2.5em;
  line-height: 0.5em;
  position: absolute;
  pointer-events: all;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 2;

  &:hover {
    color: $dark-red;
  }
}
</style>

<style lang="scss">
.InsetMap {
  .mgl-map-wrapper {
    z-index: 1;
  }

  .mapboxgl-interactive {
    cursor: default;
  }

  .mapboxgl-canvas:focus {
    outline: none !important;
  }

  .mapboxgl-map {
    .mapboxgl-ctrl {
      display: none !important;
    }
  }
}
</style>
